<template>
  <div class="sha">
    <div class="sha-con clearfix">
      <div class="sha-left">
        <el-input v-model="text" type="textarea" :rows="14" placeholder="请输入加密文本, 如: juhe.cn" />
      </div>
      <div class="sha-right">
        <el-input v-model="result" type="textarea" :rows="14" placeholder="加密结果" />
      </div>
    </div>
    <ul class="sha-list clearfix">
      <el-button type="primary" v-for="(item, i) in shaList" :key="i" @click="save(item)">{{ item.title }}</el-button>
      <el-button @click="clear">清空</el-button>
    </ul>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
export default {
  data () {
    return {
      text: '',
      result: '',
      shaList: [
        {
          title: 'SHA1'
        },
        {
          title: 'SHA3'
        },
        {
          title: 'SHA224'
        },
        {
          title: 'SHA256'
        },
        {
          title: 'SHA384'
        },
        {
          title: 'SHA512'
        }
      ]
    }
  },
  methods: {
    save (item) {
      if (this.text == '') return
      this.result = CryptoJS[item.title](this.text).toString()
    },
    clear () {
      this.text = ''
      this.result = ''
    }
  }
}
</script>

<style lang="stylus" scope>
.sha
  .sha-text
    padding-right 20px
  .sha-list
    margin 22px 0

.sha-con
  .sha-left
    float left
    width 590px
  .sha-right
    float right
    width 590px  
</style>